// extracted by mini-css-extract-plugin
export default {"background":"InfoModal_background__pVe0c","modal":"InfoModal_modal__Kcb80","btn_main":"InfoModal_btn_main__X-eoP"};